import React, { useEffect, useRef, useState } from 'react'
import { Button, Card, Col, Form, Input, Row, Space, Tabs, Typography, message } from 'antd'
import { KeyOutlined, MobileOutlined } from '@ant-design/icons'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setLogin } from '../store/loginSlice'
import { useLoginCodeMutation, useUserLoginMutation, useUserMmLoginMutation } from '../store/BnsKeJiApi'

const { Title, Text } = Typography

function H5sysLogin() {
    const prevUserPhone = JSON.parse(localStorage.getItem('eu_ba_phone') || 'null')
    const [loginInfo, setLoginInfo] = useState({ ba_phone: prevUserPhone || '', ba_pwd: '' })
    const [adminPhone, setAdminPhone] = useState(prevUserPhone || '')
    const [adminCode, setAdminCode] = useState('')
    const [isNote, setIsNote] = useState(false)
    const [time, setTime] = useState(null)
    const timeRef = useRef(null)
    const [passwordLoginSubmit, { isLoading }] = useUserMmLoginMutation()
    const [messageLoginSubmit, { isLoading: isMessageLoginLoading }] = useUserLoginMutation()
    const [getCode, { isLoading: isCodeLoading }] = useLoginCodeMutation()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if (time && time !== 0) {
            timeRef.current = setTimeout(() => {
                setTime((prev) => prev - 1)
            }, 1000)
        } else {
            setIsNote(false)
        }
        return () => {
            clearTimeout(timeRef.current)
        }
    }, [time])

    const setUserStateAndGoHome = (resultList) => {
        const arr = resultList.filter((item) => item.eu_e_id === '218')
        if (!arr.length) {
            message.error('该账号无系统访问权限')
            return
        }
        const current = arr[0]
        dispatch(
            setLogin({
                token: current.eu_token,
                eu_ba_phone: +current.eu_ba_phone,
                eu_ba_id: +current.eu_ba_id,
                eu_name: current.eu_name,
                eu_role: +current.eu_role,
                e_id: +current.e_id,
                e_name: current.e_name,
                ed_id: +current.ed_id,
                ed_name: current.ed_name,
                eu_id: +current.eu_id,
                eu_menu_id: current.eu_menu_id,
                eu_operate_id: current.eu_operate_id,
                eu_esv_id: current.eu_esv_id,
                esv: `${current.esv}`,
                eu_dept_id: current.eu_dept_id,
                e_soft_name: current.e_soft_name,
                ess_menu_id: current.ess_menu_id,
                islog: true,
            })
        )
        navigate('/H5sysHome', { replace: true })
    }

    const onPasswordFinish = () => {
        passwordLoginSubmit({
            ba_phone: loginInfo.ba_phone,
            ba_pwd: loginInfo.ba_pwd,
        }).then((res) => {
            if (res?.data?.Status === 'success') {
                setUserStateAndGoHome(res.data.Result || [])
                return
            }
            message.error(res?.data?.Message || '登录失败，请重试')
        })
    }

    const onMessageFinish = () => {
        messageLoginSubmit({
            ba_phone: adminPhone,
            phone_code: adminCode,
        }).then((res) => {
            if (res?.data?.Status === 'success') {
                setUserStateAndGoHome(res.data.Result || [])
                return
            }
            message.error(res?.data?.Message || '登录失败，请重试')
        })
    }

    const getCodeBtn = () => {
        if (!/^1[3-9]\d{9}$/.test(adminPhone)) {
            message.error('请先输入正确手机号')
            return
        }
        getCode({ phone: adminPhone }).then((res) => {
            if (res?.data?.Status === 'success') {
                setTime(60)
                setIsNote(true)
                return
            }
            message.error(res?.data?.Message || '验证码发送失败')
        })
    }

    const passwordLogin = (
        <Form layout="vertical" onFinish={onPasswordFinish}>
            <Form.Item
                label="手机号"
                name="ba_phone"
                initialValue={loginInfo.ba_phone}
                validateTrigger="onBlur"
                rules={[
                    { required: true, message: '请填写手机号' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' },
                ]}
            >
                <Input
                    size="large"
                    prefix={<MobileOutlined />}
                    placeholder="请输入手机号"
                    value={loginInfo.ba_phone}
                    onChange={(e) => setLoginInfo((prev) => ({ ...prev, ba_phone: e.target.value }))}
                />
            </Form.Item>
            <Form.Item
                label="密码"
                name="ba_pwd"
                validateTrigger="onBlur"
                rules={[{ required: true, message: '请填写登录密码' }]}
            >
                <Input.Password
                    size="large"
                    prefix={<KeyOutlined />}
                    placeholder="请输入登录密码"
                    value={loginInfo.ba_pwd}
                    onChange={(e) => setLoginInfo((prev) => ({ ...prev, ba_pwd: e.target.value }))}
                />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
                <Button type="primary" htmlType="submit" block size="large" loading={isLoading}>
                    登录
                </Button>
            </Form.Item>
        </Form>
    )

    const messageLogin = (
        <Form layout="vertical" onFinish={onMessageFinish}>
            <Form.Item
                label="手机号"
                name="adminPhone"
                initialValue={adminPhone}
                validateTrigger="onBlur"
                rules={[
                    { required: true, message: '请填写手机号' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号' },
                ]}
            >
                <Input
                    size="large"
                    prefix={<MobileOutlined />}
                    placeholder="请输入手机号"
                    value={adminPhone}
                    onChange={(e) => setAdminPhone(e.target.value)}
                />
            </Form.Item>
            <Form.Item label="验证码" style={{ marginBottom: 0 }}>
                <Row gutter={8}>
                    <Col span={14}>
                        <Form.Item
                            name="adminCode"
                            validateTrigger="onBlur"
                            rules={[
                                { required: true, message: '请输入短信验证码' },
                                { pattern: /^\d{6}$/, message: '请输入正确的6位数字验证码' },
                            ]}
                        >
                            <Input
                                size="large"
                                prefix={<KeyOutlined />}
                                placeholder="请输入验证码"
                                value={adminCode}
                                onChange={(e) => setAdminCode(e.target.value)}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={10}>
                        {isNote ? (
                            <Button block size="large" disabled>
                                {time}秒后重发
                            </Button>
                        ) : (
                            <Button block size="large" onClick={getCodeBtn} loading={isCodeLoading}>
                                获取验证码
                            </Button>
                        )}
                    </Col>
                </Row>
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
                <Button type="primary" htmlType="submit" block size="large" loading={isMessageLoginLoading}>
                    登录
                </Button>
            </Form.Item>
        </Form>
    )

    const tabItems = [
        { key: '1', label: '密码登录', children: passwordLogin },
        { key: '2', label: '短信验证码登录', children: messageLogin },
    ]

    return (
        <div
            style={{
                minHeight: '100vh',
                background: '#f5f6f8',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 16,
                boxSizing: 'border-box',
            }}
        >
            <Card variant="borderless" style={{ width: '100%', maxWidth: 420, borderRadius: 12 }}>
                <Space direction="vertical" size={14} style={{ width: '100%' }}>
                    <div>
                        <Title level={4} style={{ margin: 0 }}>
                            伯纳思后台登录
                        </Title>
                        <Text type="secondary">H5 移动端入口</Text>
                    </div>
                    <Tabs defaultActiveKey="1" items={tabItems} />
                </Space>
            </Card>
        </div>
    )
}

export default H5sysLogin